<template>
  <div class="video_player">
    <!-- <video-player
            class="video-player vjs-custom-skin"
            ref="videoPlayer"
            :playsinline="true"
            :options="playerOptions"
    ></video-player>-->
    <video id="myVideo" class="video-js">
      <!-- <source :src="videoUrl" type="video/mp4" codecs="avc1.42E01E, mp4a.40.2" /> -->
    </video>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // videoUrl: require("../../assets/video/demo.mp4"),
      playerOptions: {
        height: "300px",
        //播放速度
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        //如果true,浏览器准备好时开始回放。
        autoplay: false,
        // 默认情况下将会消除任何音频。
        muted: false,
        // 导致视频一结束就重新开始。
        loop: false,
        // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        preload: "auto",
        language: "zh-CN",
        // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        aspectRatio: "16:9",
        // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        fluid: true,
        sources: [
          {
            //类型
            type: "video/mp4",
            //url地址
            // src: require("../../assets/video/demo.mp4")
          }
        ],
        //你的封面地址
        poster: "",
        //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          //全屏按钮
          fullscreenToggle: true
        }
      }
    };
  },
  mounted() {
    this.initVideo();
  },
  methods: {
    initVideo() {
      //初始化视频方法
      let myPlayer = this.$video(myVideo, {
        //是否显示控制栏
        controls: true,
        //是否自动播放,muted:静音播放
        autoplay: false,
        //是否静音播放
        muted: false,
        //是否流体自适应容器宽高
        fluid: true,
        preload: "auto",
        
      });
    }
  }
};
</script>
<style lang="scss">
.video_player {
  width: 600px;
  height: 300px;
  margin: 34px auto 0;
  button {
    outline: none;
  }
}
.vjs-big-play-button .vjs-icon-placeholder:before {
  margin-top: 7px;
}
.vjs-slider-horizontal .vjs-volume-level:before {
  top: -0.38em;
}
.video-js .vjs-tech {
  outline: none;
}
.video-js .vjs-big-play-button {
  top: 75%;
  left: 10%;
  margin-left: -45px;
  margin-top: -24.24px;
  width: 74px;
  height: 74px;
  border: 7px solid #ffffff;
  border-radius: 50%;
}

.video-js .vjs-picture-in-picture-control {
  display: none;
}
.myVideo-dimensions.vjs-fluid {
  padding-top: 50%;
}
</style>